import MultiSelect from "components/common/MultiSelect";
import React, { useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import BootstrapDatePicker from "components/common/custom/forms/BootDatePicker";
import TextInput from "components/common/custom/forms/BootTextField/TextField";
import {
  GetAllPoyer,
  GetAllStatusEligibility,
  GetPayerInsurance,
} from "../config/eligibilityCheckListApi";
import SearchFieldWithDropdown from "components/common/custom/forms/SearchPatientWithDropDown";
import {
  GetAllIdentifierType,
  GetAllRelationShip,
} from "features/eliglibility/eliglibility-check/config/eligibilityCheckApi";
import { handleElibilityFilter } from "../config/eligibilityCheckListSlice";

const EligibilityCheckListFilter = ({
  onSubmit,
  control,
  setValue,
  watch,
  resetTrigger,
}) => {
  const dispatch = useDispatch();
  const { poyerList, payerInsurance, allStatusList, eligibilityFilters } =
    useSelector((state) => state.eligibilityCheckList);

  const { identifierTypeList } = useSelector((state) => state.eligibilityCheck);
  useEffect(() => {
    if (poyerList?.length === 0) dispatch(GetAllPoyer());
    if (allStatusList?.length === 0 || !allStatusList?.length)
      dispatch(GetAllStatusEligibility());
    if (identifierTypeList?.length === 0) dispatch(GetAllIdentifierType());
  }, []);

  useEffect(() => {
    setValue("payer", eligibilityFilters?.payer);
    setValue("insurance", eligibilityFilters?.insurance_company);
    setValue("start_date", eligibilityFilters?.start_date);
    setValue("end_date", eligibilityFilters?.end_date);
    setValue("identifier_type", eligibilityFilters?.identifier_type);
    setValue("status", eligibilityFilters?.status);
  }, []);

  useEffect(() => {
    if (eligibilityFilters?.patient) {
      setValue("patient", eligibilityFilters.patient);
    }
  }, [eligibilityFilters?.patient, setValue]);

  useEffect(() => {
    const selectedPayer = watch("payer");

    if (selectedPayer && selectedPayer.payer_id) {
      dispatch(GetPayerInsurance({ payer_id: selectedPayer.payer_id }));
    } else {
      dispatch(GetPayerInsurance({ payer_id: null })); // optional: to clear insurance
    }
  }, [watch("payer")]);

  const handlePayer = (selected) => {
    if (!selected) {
      setValue("payer", null);
      setValue("insurance", null);
      dispatch(handleElibilityFilter({ check: "payer", value: null }));
      dispatch(
        handleElibilityFilter({ check: "insurance_company", value: null })
      );
      return;
    }

    const value = {
      payer_name: selected.label,
      payer_id: selected.value,
    };
    setValue("payer", value);
    dispatch(handleElibilityFilter({ check: "payer", value }));
  };

  const handleInsurance = (selected) => {
    if (!selected) {
      setValue("insurance", null);
      dispatch(
        handleElibilityFilter({ check: "insurance_company", value: null })
      );
      return;
    }

    const value = {
      insurance_company_name: selected.label,
      insurance_company_id: selected.value,
    };
    setValue("insurance", value);
    dispatch(handleElibilityFilter({ check: "insurance_company", value }));
  };

  const handleIdentifierType = (selected) => {
    if (!selected) {
      setValue("identifier_type", null);
      dispatch(
        handleElibilityFilter({ check: "identifier_type", value: null })
      );
      return;
    }

    const value = {
      ident_type_id: selected.value,
      ident_type_name: selected.label,
    };
    setValue("identifier_type", value);
    dispatch(handleElibilityFilter({ check: "identifier_type", value }));
  };

  const handleStartDate = (selected) => {
    setValue("start_date", selected);

    dispatch(
      handleElibilityFilter({
        check: "start_date",
        value: selected,
      })
    );
  };
  const handleEndDate = (selected) => {
    setValue("end_date", selected);

    dispatch(
      handleElibilityFilter({
        check: "end_date",
        value: selected,
      })
    );
  };
  const handleStatus = (selected) => {
    if (!selected) {
      setValue("status", null);
      dispatch(handleElibilityFilter({ check: "status", value: null }));
      return;
    }

    const value = {
      allstatus_name: selected.label,
      allstatus_code: selected.value,
    };
    setValue("status", value);
    dispatch(handleElibilityFilter({ check: "status", value }));
  };

  return (
    <Row alignItems="center">
      {/* PAYER */}
      <Col xs={12} sm={6} md={3} xl={2}>
        <Form.Group controlId="payer">
          <Form.Label>Payer</Form.Label>
          <Controller
            name="payer"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <>
                <MultiSelect
                  {...field}
                  menuPlacement="auto"
                  closeMenuOnSelect={false}
                  isMulti={false}
                  size="sm"
                  options={poyerList?.map((poyer) => ({
                    value: poyer.payer_id,
                    label: poyer.payer_name,
                  }))}
                  placeholder="Choose..."
                  isClearable={true}
                  className={error ? "is-invalid" : ""}
                  value={
                    field.value
                      ? {
                          value: field.value.payer_id,
                          label: field.value.payer_name,
                        }
                      : null
                  }
                  onChange={(selected) => handlePayer(selected)}
                />
              </>
            )}
          />
        </Form.Group>
      </Col>

      {/* INSURANCE */}
      <Col xs={12} sm={6} md={3} xl={2}>
        <Form.Group controlId="insurance">
          <Form.Label>Insurance</Form.Label>
          <Controller
            name="insurance"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <>
                <MultiSelect
                  {...field}
                  menuPlacement="auto"
                  closeMenuOnSelect={false}
                  isMulti={false}
                  size="sm"
                  isClearable={true}
                  options={
                    eligibilityFilters?.payer
                      ? payerInsurance?.map((poyer) => ({
                          value: poyer.insurance_company_id,
                          label: poyer.insurance_company_name,
                        }))
                      : []
                  }
                  placeholder="Choose..."
                  className={error ? "is-invalid" : ""}
                  value={
                    field.value
                      ? {
                          value: field.value.insurance_company_id,
                          label: field.value.insurance_company_name,
                        }
                      : null
                  }
                  onChange={(selected) => handleInsurance(selected)}
                />
              </>
            )}
          />
        </Form.Group>
      </Col>

      {/* SEARCH FIELD */}
      <SearchFieldWithDropdown
        resetTrigger={resetTrigger}
        setValue={setValue}
        watch={watch}
      />

      {/* IDENTIFIER TYPE */}
      <Col xs={12} sm={6} md={3} xl={2}>
        <label className="form-label">Identifier Type</label>
        <Controller
          name="identifier_type"
          control={control}
          rules={{ required: false }}
          render={({ field }) => (
            <MultiSelect
              {...field}
              menuPlacement="auto"
              closeMenuOnSelect={false}
              isMulti={false}
              options={identifierTypeList?.map((item) => ({
                value: item.ident_type_id,
                label: item.ident_type_name,
              }))}
              isClearable={true}
              value={
                field.value
                  ? {
                      value: field.value.ident_type_id,
                      label: field.value.ident_type_name,
                    }
                  : null
              }
              onChange={(selected) => handleIdentifierType(selected)}
              formatOptionLabel={({ label }) => <div>{label}</div>}
              getOptionValue={(option) => option.value}
              placeholder="Choose ..."
            />
          )}
        />
      </Col>

      {/* START DATE */}
      <Col xs={12} sm={6} md={3} xl={2}>
        <BootstrapDatePicker
          name="start_date"
          label="Start Date"
          size="sm"
          control={control}
          selected={watch("start_date")}
          onChange={(date) => handleStartDate(date)}
          placeholder="dd/mm/yyyy"
        />
      </Col>

      {/* END DATE */}
      <Col xs={12} sm={6} md={3} xl={2}>
        <BootstrapDatePicker
          name="end_date"
          label="End Date"
          size="sm"
          control={control}
          selected={watch("end_date")}
          onChange={(date) => handleEndDate(date)}
          placeholder="dd/mm/yyyy"
        />
      </Col>

      {/* STATUS */}
      <Col xs={12} sm={6} md={3} xl={2}>
        <Form.Group controlId="status">
          <Form.Label>Status</Form.Label>
          <Controller
            name="status"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <>
                <MultiSelect
                  {...field}
                  menuPlacement="auto"
                  closeMenuOnSelect={false}
                  isMulti={false}
                  size="sm"
                  options={allStatusList?.map((poyer) => ({
                    value: poyer.allstatus_code,
                    label: poyer.allstatus_name,
                  }))}
                  placeholder="Choose..."
                  isClearable={true}
                  className={error ? "is-invalid" : ""}
                  onOpen={() => {
                    if (allStatusList?.length === 0)
                      dispatch(GetAllStatusEligibility());
                  }}
                  value={
                    field.value
                      ? {
                          value: field.value.allstatus_code,
                          label: field.value.allstatus_name,
                        }
                      : null
                  }
                  onChange={(selected) => handleStatus(selected)}
                />
              </>
            )}
          />
        </Form.Group>
      </Col>
    </Row>
  );
};

export default EligibilityCheckListFilter;
